import React from "react";
import {Box, Button, IconButton, Stack, TextField, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Add01Icon, Delete02Icon} from "@hugeicons/core-free-icons";
import {VariableTextField} from "./VariableTextField";
import {UI, rgba} from "../../uiTokens";
import {fieldSx, iconBtnDangerSx, sectionLabelSx} from "../editMenuStyles";

/**
 * A list of multiline message cards with add / delete, shared by the greet and
 * please-wait message tabs. Pass `variables` to use the variable-aware field.
 */
export const MessageListEditor = ({
                                      messages = [],
                                      onChange,
                                      onCommit,
                                      onRemove,
                                      onAdd,
                                      variables,
                                      itemLabel = "Message",
                                      addLabel = "Add message",
                                      emptyLabel = "No messages yet.",
                                  }) => (
    <>
        {messages.length === 0 && (
            <Typography sx={{fontSize: 12, color: rgba(UI.muted, 0.85)}}>{emptyLabel}</Typography>
        )}

        <Stack gap={1}>
            {messages.map((message, index) => (
                <Box
                    key={index}
                    sx={{p: 1, borderRadius: "10px", border: `1px solid ${rgba(UI.ink, 0.1)}`, backgroundColor: UI.surface}}
                >
                    <Stack direction="row" alignItems="center" sx={{mb: 0.5}}>
                        <Typography sx={{...sectionLabelSx, flex: 1}}>{itemLabel} {index + 1}</Typography>
                        <Tooltip title="Delete" disableInteractive>
                            <IconButton size="small" sx={iconBtnDangerSx} onClick={() => onRemove(index)}>
                                <HugeiconsIcon icon={Delete02Icon} size={15}/>
                            </IconButton>
                        </Tooltip>
                    </Stack>
                    {variables ? (
                        <VariableTextField
                            value={message}
                            variables={variables}
                            size="small"
                            placeholder="Write here message..."
                            sx={{width: "100%", ...fieldSx}}
                            multiline
                            minRows={3}
                            maxRows={5}
                            onChange={(v) => onChange(index, v)}
                            onBlur={() => onCommit?.()}
                        />
                    ) : (
                        <TextField
                            value={message}
                            size="small"
                            placeholder="Write here message..."
                            sx={{width: "100%", ...fieldSx}}
                            multiline
                            minRows={3}
                            maxRows={5}
                            onChange={(e) => onChange(index, e.target.value)}
                            onBlur={() => onCommit?.()}
                        />
                    )}
                </Box>
            ))}
        </Stack>

        <Button
            size="small"
            startIcon={<HugeiconsIcon icon={Add01Icon} size={15}/>}
            onClick={onAdd}
            sx={{
                alignSelf: "flex-start",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "8px",
                color: UI.accent,
                "&:hover": {backgroundColor: rgba(UI.accent, 0.1)},
            }}
        >
            {addLabel}
        </Button>
    </>
);
